import React from 'react'
import { Select } from 'antd'
import _ from 'lodash'
import { useTranslation } from 'react-i18next'
import { globalKeyFigureConfig, GlogalKeyFigureMap } from '../config'

interface KeyFigureInputProps {
  mode?: 'multiple' | 'tags'
  value?: number[]
  onChange?: (value: number[]) => void
}

const GlobalKeyFigureInput: React.FC<KeyFigureInputProps> = ({ value, onChange, mode }) => {
  const { t } = useTranslation()
  const triggerChange = (changedValue: number[]) => {
    onChange?.(changedValue as number[])
  }
  return (
    <Select
      filterOption={(input, option) => {
        const { children } = option?.props

        if (option?.type?.isSelectOptGroup) {
          return children.includes(
            (child: any) => child?.props?.children?.toLowerCase().indexOf(input?.toLowerCase()) >= 0
          )
        }
        return children?.toLowerCase()?.indexOf(input?.toLowerCase()) >= 0
      }}
      value={value}
      showSearch
      mode={mode}
      allowClear
      onChange={triggerChange}
      maxTagCount="responsive"
    >
      {Object.entries(_.groupBy(globalKeyFigureConfig, 'group')).map(([groupId, groupKeyFigures]) => (
        <Select.OptGroup key={groupId} label={t(`keyFigurePage:${groupId}`)}>
          {groupKeyFigures.map((keyF: GlogalKeyFigureMap) => (
            <Select.Option key={keyF.id} value={keyF.id}>
              {t(`globalKeyFigureStatement:${keyF.id}`)}
            </Select.Option>
          ))}
        </Select.OptGroup>
      ))}
    </Select>
  )
}

export default GlobalKeyFigureInput
